import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule } from '@angular/forms';

import { TranslocoModule } from '@ngneat/transloco';

import { DirectiveModule } from '@shared/directives/directive.module';
import { MaterialModule } from '@shared/material.module';

import { ValidationMessageModule } from '../validation-message/validation-message.module';
import { DateRangeComponent } from './date-range.component';

@NgModule({
    declarations: [DateRangeComponent],
    imports: [
        CommonModule,
        TranslocoModule,
        FormsModule,
        ValidationMessageModule,
        MaterialModule,
        FlexLayoutModule,
        DirectiveModule,
    ],

    exports: [DateRangeComponent],
})
export class VscDateRangeModule {}
